import { ElementRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TemplatesService } from '../templates/templates.service';
import { EmployeeService } from '../employee-profile/employee-profile.service';
import { SharedSkillService } from '../skill-repository/shared-skill.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { auditTime, takeUntil } from 'rxjs/operators';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';
import { TemplateUploadModalComponent } from '../template-upload-modal/template-upload-modal.component';
import { UserRoles } from 'src/app/enums/userRoles.enum';
import { AttachmentsModel } from 'src/app/Models/attachments.model';
import { InfoDialogComponent } from 'src/app/components/info-dialog/info-dialog.component';
import { Location } from "@angular/common";
import { AttachmentTypes, UploadFileResponse } from '../projects/project-detail/project-detail.component';
import { TemplateCategoryModalComponent } from '../template-category-modal/template-category-modal.component';
import { auto } from '@popperjs/core';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { MatTooltip } from '@angular/material/tooltip';
@Component({
  selector: 'app-template-creation',
  templateUrl: './template-creation.component.html',
  styleUrls: ['./template-creation.component.css']
})
export class TemplateCreationComponent implements OnInit, OnDestroy {
  project: any;
  public formData: UntypedFormGroup;
  public contentTypes = ["Corporate Deck", "Industry Deck", "Template"];
  private filesChanged: boolean;
  private matdialog: MatDialog;
  private location: Location;
  public attachmentTypes = AttachmentTypes;
  title: string = ""

  public uploads: Array<AttachmentsModel>;
  flag: boolean = false
  flag1: boolean = false
  flag2: boolean = false
  filteredValues: any[] = [];
  loading = false;
  thumbnail = false;
  tfile = false
  mode: string;
  searchTerm: string = '';
  a: any = null;
  employee: any = {};
  originalServiceLinesForDropDown: any[];
  projectType = "";
  role = "";
  selectedFileNames: string[] = [];
  isView: boolean;
  category: any;
  isApproved: boolean;
  isPending: boolean;
  deliveryOrganizations: any;
  templatesArray: any = []
  list = []
  permissions = {
    canViewNotes: false,
    canAddProject: false,
    canApproveProject: false,
  };
  @ViewChild('file', { static: false }) fileInput: ElementRef<HTMLInputElement>;

  @ViewChild('tooltipTags') tooltipTags: ElementRef;
  @ViewChild(MatTooltip) tooltip: MatTooltip;

  constructor(public dialogRef: MatDialogRef<TemplateUploadModalComponent>, private dialog: MatDialog, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _templateService: TemplatesService,
    private _proposalService: AddProposalService,
    private auth: AuthServiceService,
    private employeeService: EmployeeService,
    public sharedSkillService: SharedSkillService,
    private toastr: ToastrService,
    private templateService : TemplatesService
  ) {
    this.uploads = new Array<AttachmentsModel>();
  }
  private unsubscribe = new Subject<void>();

  showAlert: boolean;
  alertMessage: string;
  selectedServiceLine: string;
  showCategory: boolean = false;
  hasUploadClicked: boolean = false;
  certificateUpload: boolean = false;
  subCategories: any = [];
  public serviceLinesForDropDown: any = [];
  public sub: any;
  public serviceLines: any = [];
  public subServiceValues: any = [];
  public serviceLinesValues: any = [];
  public domains: any = [];
  serviceOfferingForDropDownValues: any;
  competencies: any = [];
  templates: any = [];
  subTemplates: any = [];
  subCompetencies: any = [];
  selectedCategory: number = 0;
  public selectedFiles: any = [];
  public selectedFiles1: any = [];
  editModeData: any = [];
  requestData: any = [];
  description: string;
  subcategory: any = [];
  template: any = [];
  subTemplate: any = [];
  dropdowns: Dropdown[] = [];
  optionarray = [];
  subTemplatess: boolean = true;
  competency: boolean = true;
  subCompetecy: boolean = true;
  istemplateselected: boolean = false
  loggedUser: any

  isFileRangeExceeded: boolean = false;
  Files = new UntypedFormControl();

  ngOnInit() {
    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialogRef.close();
      }
    });

    this.getDomains();
    if (this.data.domain == null) {
      this.data.domain = undefined;
    }
    if (this.data && this.data.categoryTypes) {
      this.showCategory = true;

      this.templates = this.data.categoryTypes
      // if (this.data.subCategoryTemplateId)
      //   this.subTemplates = this.data.categoryTypes[this.data.templateId - 1].subCategories
      if (this.data.title !== "Add ") {
        this.subTemplates = this.data.categoryTypes[this.data.templateId - 1].subCategories
      }
      else {
        this.data.subCategoryTemplateId = 0;
      }

    }
    else {
      this.getTemplates();
    }
    if (this.data?.templateId) {
      let event = {
        value: this.data?.templateId
      }
      this.templateCategoryChange(event);
    }
    this.showAlert = false;

    this.title = this.data.title


    if (this.data.logoName) {
      this.selectedFiles.push({ name: this.data.logoName, logo: this.data.logo })
      this.selectedFiles1.push({ name: this.data.name, fileBase64: this.data.fileBase64 })
    }

    if (this.data && this.data.certificateCategoryTypes) {
      this.certificateUpload = true;
    }
    this.createFormControls();
    if (this.data?.contactPerson) {
      this.formData.get('contactPerson').disable();
    }
    this.serviceLines = [];
    this.data.serviceLines?.forEach(item => {
      if (item.id === this.data.competency) {
        this.serviceLines.push(item);
      }
    });
    if (this.data && this.data?.serviceLinesForDropDown) {
      this.getServiceLinesForDropDownvaluesInEditMode(this.data?.serviceLineName)
    }
    this.loggedUser = this.auth.getEmailId().split('@')[0].replace('.', ' ');
    const uniqueServiceLines = Array.from(new Set(this.data?.serviceLinesForDropDown?.map(item => item.name)));
    this.originalServiceLinesForDropDown = uniqueServiceLines.map(name => {
      return this.data?.serviceLinesForDropDown.find(item => item.name === name);
    });
    if (this.serviceLines.length == 0 && this.data.serviceLine > 0) {
      this.originalServiceLinesForDropDown.forEach(val => {
        this.data.serviceLines.forEach(item => {
          if (val.name == this.data.serviceLineName && item.id == val.competencyId) {
            this.serviceLines.push(item);
          }
        })
      })
    }
    if (this.data.competency == 0) {
      this.data.competency = undefined;
    }
    if (this.data.subCompetency == 0) {
      this.data.subCompetency = undefined;
    }
    if (this.data.serviceOffering == 0) {
      this.data.serviceOffering = undefined;
    }

    this.updateControlStates(this.formData.get('hasApproval')?.value);

     this.formData.get('hasApproval')?.valueChanges.subscribe((value: boolean) => {
        this.updateControlStates(value);
    });

  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  getServiceAreas(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._proposalService.getServiceAreas().subscribe(x => {
        if (x.data && Array.isArray(x.data)) {
          x.data.forEach(tech => {
            this.serviceLinesForDropDown.push(
              tech
            );
            this.originalServiceLinesForDropDown = [...this.serviceLinesForDropDown];
          });
        }
      });
      resolve(this.serviceLinesValues);
    })


  }


  getServiceLinesForDropDownvalues(event) {
    this.selectedServiceLine = event.option.value
    let data = this.serviceLinesForDropDown.filter((item) => item.name == event.option.value);
    const inputStrings = data[0].serviceAreaInfo;
    const listStartRegex = /\b1\./;
    const items = () => {
      const match = inputStrings.match(/<p>([\s\S]*?)<\/p>/);
      if (match) {
        const startIndex = match[1].search(listStartRegex);
        if (startIndex !== -1) {
          const content = match[1].substring(startIndex);
          return content.split('<br/>').map(item => item.trim().replace(/^\d+\./, ''));
        }
      }
      return [];
    };

    const flattenedItems = items().flat();
    this.serviceOfferingForDropDownValues = flattenedItems.map((item, index) => ({
      name: item,
      id: index
    }));

    this.serviceLines = [];
    this.data.competency = 0;
    this.data.subCompetency = 0;
    this.data.serviceOfferingName = null;
    this.data.serviceOffering = 0;
    let a = data[0].competencyId;
    this.getCompetenciesForDropdown(a);
    if (this.serviceLines[0]?.name != data[0]?.name) {
      this.subServiceValues = null;
    }
    if (this.flag)
      this.a = this.formData.getRawValue()
    if (this.data.competency > 0) {
      this.setSubServiceLineValuesInEditMode(this.data.competency)
    }
  }
  filterServiceLineValues(a) {
    if (a.trim() === '') {
      this.data.competency = undefined;
      this.data.subCompetency = undefined;
      this.data.serviceOffering = undefined;
      this.serviceOfferingForDropDownValues = [];
      this.serviceLines = [];
      this.subServiceValues = [];
      this.serviceLinesForDropDown = [...this.originalServiceLinesForDropDown];
    } else {
      this.serviceLinesForDropDown = this.originalServiceLinesForDropDown.filter(x => x.name.toLowerCase().includes(a.toLowerCase()));
    }
  }
  domainChange() {
    if (this.flag) {
      this.a = this.formData.getRawValue()
    }
  }
  getServiceLinesForDropDownvaluesInEditMode(event) {

    let data = this.data.serviceLinesForDropDown.filter((item) => item.name == event);
    const inputStrings = data[0].serviceAreaInfo;
    const listStartRegex = /\b1\./;
    const items = () => {
      const match = inputStrings.match(/<p>([\s\S]*?)<\/p>/);
      if (match) {
        const startIndex = match[1].search(listStartRegex);
        if (startIndex !== -1) {
          const content = match[1].substring(startIndex);
          return content.split('<br/>').map(item => item.trim().replace(/^\d+\./, ''));
        }
      }
      return [];
    };
    const flattenedItems = items().flat();

    this.serviceOfferingForDropDownValues = flattenedItems.map((item, index) => ({
      name: item,
      id: index
    }));
    let a = data[0].competencyId;
    this.setSubServiceLineValuesInEditMode(this.data.competency);
  }

  getCompetenciesForDropdown(a) {
    this.subServiceValues = null;
    this._proposalService.getServiceLines2(a).subscribe(x => {
      this.sub = x.data;
      var s = this.serviceLines.some(x => x.name == this.sub.name);
      if (!s) {
        this.serviceLines.push(this.sub)
      }
      this.data.competency = undefined;
      this.data.subCompetency = undefined;
      this.data.serviceOffering = undefined;
      if (x.data && Array.isArray(x.data)) {
        x.data.forEach(ser => {
          x = this.serviceLines.some(x => x.name == ser.name);
          if (!x) {
            this.serviceLines.push(ser);
          }
        });
      }
      this.loading = false;
    })
  }

  getDomains(): Promise<any[]> {
    this.domains = [];
    return new Promise<any[]>((resolve, reject) => {
      this._proposalService.getDomains().subscribe(x => {
        let y = x.data.items.map(item => item.name);
        this.domains = y;
        resolve(this.domains)
      });
    });
  }


  setSubServiceLineValues(a) {
    this.subServiceValues = [];
    return new Promise<void>((resolve, reject) => {

      const requests = this.serviceLines.map(x => {
        return this._proposalService.getSubServiceLines(Number(a.value)).toPromise();
      });
      Promise.all(requests)
        .then(responses => {
          responses.forEach(res => {
            res.data.forEach(temp => {
              this.subServiceValues.push(temp);

            });
          });
          resolve(this.subServiceValues);
        })
    });


  }


  setSubServiceLineValuesInEditMode(a): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const requests = this.serviceLines.map(x => {
        return this._proposalService.getSubServiceLines(Number(a)).toPromise();
      });
      this.subServiceValues = [];
      Promise.all(requests)
        .then(responses => {

          responses.forEach(res => {
            res.data.forEach(temp => {
              this.subServiceValues.push(temp);

            });
          });
          resolve(this.subServiceValues);
        })
    });
  }

  Onchange() {
    if (this.flag)
      this.a = this.formData.getRawValue()
  }
  getFilteredValues(event: any) {
    const specialCharsRegex = /[!#$%^&*_+\-=\[\]{};':"\\|,.<>\/?~]/; 
  
    if (event && specialCharsRegex.test(event)) {
      this.filteredValues = [];
    } else {
      this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
        this.filteredValues = res.data ? res.data.profiles : [];
      });
    }
  }
  setCurrentEmployee(value: any) {
    this.employee = {}
    this.sharedSkillService.setEmployeeId(value);
    this.getEmployeeDetalis(value)
  }
  getEmployeeDetalis(empId?: string) {
    if (!empId)
      empId = this.sharedSkillService.getEmployeeId()

    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(res => {
        res.data.competencies?.forEach(c => {
          c.subCompetencies?.forEach(s => {
            s.certificates?.forEach(sc => {
              if (sc.status == 2) {
                sc.status = 1;
                sc.plannedDate = sc.expiryDate;
                sc.expiryDate = null;
              }
              return sc
            })
            return s
          })
          return c
        });
        this.employee = res.data;
        this.loading = false;
      }, error => {
        this.loading = false;
      });
    }
  }
  TemplateCategoryDialog() {
    const dialogRef = this.dialog.open(TemplateCategoryModalComponent, {
      width: '500px',
      height: auto,
      panelClass: 'view-file',
      data: { title: "templateCategory" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._templateService.AddTemplateCategory(result).subscribe(res => {
          this.loading = true;
          this.templateService.changeData(true);
          setTimeout(() => { this.getTemplates() }, 3000)
          this.toastr.success("Artifactory Category Added Successfully")
        })

      }


    });

  }
  SubTemplateCategoryDialog() {
    let b = parseInt(this.formData.value.templateId)
    let sharepointId = this.templates[b - 1].sharepointId
    let templateCategory = this.templates[b - 1].category

    const dialogRef = this.dialog.open(TemplateCategoryModalComponent, {
      width: '500px',
      height: 'auto',
      panelClass: 'view-file',
      data: { title: "templateType", templateCategory, sharepointId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._templateService.AddSubTemplateCategory(result).subscribe(res => {
          this.loading = true;
          setTimeout(() => { this.getSubTemplates(1) }, 3000)
          this.toastr.success("Artifactory Category Type Added Successfully")
          setTimeout(() => { this.getSubTemplates(b) }, 3000)
        })


      }
    });
  }
  onFileChange(data) {
    const selectedOptionsSet = new Set(
      this.dropdowns.map((dropdown) => dropdown.selectedOptions)
    );

    this.optionarray = this.data.categoryTypes.filter(
      (optioned) => !selectedOptionsSet.has(optioned)
    );

    const dropdown = new Dropdown(this.optionarray);
    this.dropdowns.push(dropdown);
    this.selectedFiles = []

    var x = Array.from(data);
    x = [...new Set(x)];
    x.forEach(async (element: File) => {
      if (this.isFileSelected(element)) {
        this.toastr.warning("This file is already selected.")
        return;
      }

      let processedFile = await Promise.resolve(this.convertFile(element))
      const extension = element.name.split('.').pop()
      let extensionTypes = ['.png', '.jpg', '.jpeg']
      if (extension != 'png' && extension != 'jpg' && extension != 'jpeg') {

        this.thumbnail = true
        this.formData.controls['logo'].setErrors({invalid:true})
        return;
      }
      else {
        this.thumbnail = false
      }
      element['dropdown'] = dropdown
      this.selectedFiles.push(
        element
      );
      this.flag1 = true
      this.addSelectedFile(element);
    });
    if (this.flag)
      this.a = this.formData.getRawValue()


  }
  onFileChange1(data) {
    const selectedOptionsSet = new Set(
      this.dropdowns.map((dropdown) => dropdown.selectedOptions)
    );

    this.optionarray = this.data.categoryTypes.filter(
      (optioned) => !selectedOptionsSet.has(optioned)
    );

    const dropdown = new Dropdown(this.optionarray);
    this.dropdowns.push(dropdown);
    this.selectedFiles1 = []

    var x = Array.from(data);
    x = [...new Set(x)];
    x.forEach(async (element: File) => {
      if (this.isFileSelected(element)) {
        this.toastr.warning("This file is already selected.")
        return;
      }

      let processedFile = await Promise.resolve(this.convertFile(element))
      const extension = element.name.split('.').pop()
      let extensionTypes = ['.ppt', '.pptx', '.pdf', '.doc', '.docx']
      if (extension != 'ppt' && extension != 'pptx' && extension != 'pdf' && extension != 'doc' && extension != 'docx' && extension != 'xls' && extension != 'xlsx') {

        this.tfile = true
        this.formData.controls['filebase64'].setErrors({invalid:true})
        return;
      }
      else {
        this.tfile = false
      }
      element['dropdown'] = dropdown
      this.selectedFiles1.push(
        element
      );
      this.flag2 = true
      this.addSelectedFile(element);
    });
    if (this.flag)
      this.a = this.formData.getRawValue()

  }

  async createFormControls(): Promise<void> {

    this.formData = new UntypedFormGroup({
      GitLink: new UntypedFormControl(
        this.data?.gitLink ? this.data.gitLink : "",
        [Validators.pattern(/^https:\/\/(gitlab(\.[a-zA-Z0-9._-]+)?\.com|github(\.[a-zA-Z0-9._-]+)?\.com)\/[a-zA-Z0-9._\-\/]+$/)]
      ),

      purposeOfUsage: new UntypedFormControl(
        this.data?.purposeOfUsage ? this.data.purposeOfUsage :
          "", [Validators.required, Validators.maxLength(150), Validators.pattern('^[a-zA-Z0-9]+[a-zA-Z0-9\-_., ]*$')]
      ),
      TemplateDescription: new UntypedFormControl(
        this.data?.templateDescription ? this.data.templateDescription :
          "", [Validators.required, Validators.maxLength(150), Validators.minLength(30), Validators.pattern('^[a-zA-Z]+[a-zA-Z0-9\-_., ]*$')]
      ),
      companyName: new UntypedFormControl(""

      ),
      contactPerson: new UntypedFormControl({ value: this.data?.contactPerson ? this.data.contactPerson : "", disabled: this.data?.emailAddress ? (this.auth.getEmailId() != this.data.emailAddress) : false }
        , [Validators.required, Validators.maxLength(40), Validators.pattern('^[a-zA-Z ]*$')]
      ),
      templateId: new UntypedFormControl(this.data?.templateId ? this.data?.templateId : "", Validators.required),
      serviceLineName: new UntypedFormControl(this.data?.serviceLineName ? this.data?.serviceLineName : "", Validators.required),
      Domain: new UntypedFormControl(this.data?.domain ? this.data?.domain : "", Validators.required),
      SubCategoryTemplateId: new UntypedFormControl(this.data?.SubCategoryTemplateId),
      ServiceOffering: new UntypedFormControl(this.data?.ServiceOffering ? this.data.ServiceOffering : "", Validators.required),
      Competency: new UntypedFormControl(this.data?.Competency ? this.data.Competency : "", Validators.required),
      SubCompetency: new UntypedFormControl(this.data?.SubCompetency ? this.data.SubCompetency : "", Validators.required),
      changesAllowed: new UntypedFormControl({ value: this.data?.changesAllowed ? this.data?.changesAllowed : true, disabled: this.data?.emailAddress ? (this.auth.getEmailId() != this.data.emailAddress) : false }

      ),
      TemplateTags: new UntypedFormControl(
        this.data?.templateTags ? this.data.templateTags :
          "", [Validators.required, Validators.maxLength(150), Validators.pattern('^[a-zA-Z#]+[a-zA-Z#., ]*$')]),
      Name: new UntypedFormControl(
        this.data?.fileName ? this.data.fileName :
          ""
        , [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z]+[a-zA-Z ]*$')]
      ),
      clientLogo: new UntypedFormControl(
        this.data?.clientLogo ? this.data.clientLogo :
          ""
      ),
      logo: new UntypedFormControl(this.data?.logoName ? this.data.logoName : "", [Validators.required]),
      filebase64: new UntypedFormControl(this.data?.name ? this.data.name : "", Validators.required),
      
      hasApproval: new UntypedFormControl(this.data?.hasApproval ? this.data?.hasApproval : false , [Validators.required]),
      MailProofFile: new UntypedFormControl(this.data?.mailProofFile ? this.data?.mailProofFile : "" ,
        [Validators.required, Validators.pattern(/^https:\/\/(gitlab(\.[a-zA-Z0-9._-]+)?\.com|github(\.[a-zA-Z0-9._-]+)?\.com)\/[a-zA-Z0-9._\-\/]+$/)]
      ),

    });

    await this.getServiceAreas()
    setTimeout(() => {
    }, 5000);
    if (this.isView) {
      this.formData.disable();
    }
    if (this.role != UserRoles.SuperAdmin) {
      this.formData.get("companyName").disable();
    }
  }
  handleFileInput(files: FileList, fileType) {
    // size 10,00,000 = 1MB
    if (files && files.item && files.item(0).size > 25000000) {
      this.showDialog("File size too large please select below 25MB");
      return;
    }
    this.filesChanged = true;
    const attachment = new AttachmentsModel();
    attachment.fileName = files.item(0).name;
    attachment.file = files.item(0);
    attachment.id = fileType;
    if (this.uploads && this.uploads.length) {
      const fileTypeIndex = this.uploads.findIndex((ele) => ele.id == fileType);
      if (fileTypeIndex === -1) {
        this.uploads.push(attachment);
      } else {
        this.uploads[fileTypeIndex] = attachment;
      }
    } else {
      this.uploads.push(attachment);
    }
  }
  async OnSubmit() {
     if (!this.hasApproval) {
        this.dialogRef.close();
        return;
    }
    this.flag = true
    this.a = this.formData.getRawValue()
    if (this.formData.invalid) {
      // Mark all form controls as touched to trigger validation errors
      this.formData.markAllAsTouched();
      return;
    }

    if (!(this.a.purposeOfUsage && this.a.TemplateDescription
      && this.a.contactPerson && this.a.templateId && this.a.Domain
      && this.a.TemplateTags && this.a.Name && this.a.serviceLineName
      && (this.selectedFiles[0].name) && (this.selectedFiles1[0].name))) {

      return;
    }
    if (this.filteredValues.length > 0 && !this.filteredValues.find(s => s.name == this.a.contactPerson)) {
      this.formData.controls.contactPerson.setErrors({
        'invalid': true
      });
      return;
    }
    if (!Array.isArray(this.a.TemplateTags)) {
      this.a.TemplateTags = this.a.TemplateTags.split(",");
    }
    if (this.a.TemplateDescription.length < 30 || this.a.Name.match('^[a-zA-Z]+[a-zA-Z ]*$') == null ||
      this.a.contactPerson.match('^[a-zA-Z]+[a-zA-Z. ]*$') == null ||
      this.formData.controls.GitLink.invalid) {
      return
    }
    if (this.data) {
      this.a.id = this.data.id
    }
    if (this.flag1) {
      let processedFile = await Promise.resolve(this.convertFile(this.selectedFiles[0]));
      this.a.LogoName = this.selectedFiles[0].name
      this.a.logo = processedFile.toString().split(",")[1]
    }
    else {
      this.a.LogoName = this.selectedFiles[0].name
      this.a.logo = this.selectedFiles[0].logo
    }
    if (this.flag2) {
      let processedFile1 = await Promise.resolve(this.convertFile(this.selectedFiles1[0]));
      this.a.FileName = this.selectedFiles1[0].name
      this.a.filebase64 = processedFile1.toString().split(",")[1]
    }
    else {
      this.a.FileName = this.selectedFiles1[0].name
      this.a.filebase64 = this.selectedFiles1[0].fileBase64
    }
    const extension = this.selectedFiles1[0].name.split('.').pop()
    const MimeType = this.selectedFiles1[0].type || null
    let serviceLineId
    let selectedServiceLineName
    if (this.data.serviceLineName) {
      selectedServiceLineName = this.data.serviceLineName
    }
    else {
      selectedServiceLineName = this.selectedServiceLine;
    }
    if (selectedServiceLineName) {
      let serviceLineData = this.serviceLinesForDropDown.filter((item) => item.name == selectedServiceLineName);
      serviceLineId = serviceLineData[0].id;
    }
    this.a.templateId = parseInt(this.a.templateId)
    this.a.ServiceLine = parseInt(serviceLineId)
    if (this.a.ServiceOffering) {
      {
        this.a.ServiceOffering = parseInt(this.a.ServiceOffering)
      }
    }
    if (this.a.Competency) {
      this.a.Competency = parseInt(this.a.Competency)
    }
    if (this.a.SubCompetency) {
      this.a.SubCompetency = parseInt(this.a.SubCompetency)
    }

    let b = this.a.Name
    this.a.Name = this.a.FileName
    this.a.FileName = b




    this.a.SharepointFolderId = this.templates[this.a.templateId - 1].sharepointId

    this.a.SubCategoryTemplateId = this.a.SubCategoryTemplateId || 0
    this.a.SubCategoryTemplate = this.a.SubCategoryTemplate || null
    if (this.a.SubCategoryTemplateId) {
      this.a.SubCategoryTemplateId = parseInt(this.a.SubCategoryTemplateId)
      this.a.SharepointFolderId = this.subTemplates[this.a.SubCategoryTemplateId - 1].sharepointId
      this.a.SubCategoryTemplate = this.subTemplates[this.a.SubCategoryTemplateId - 1].subCategory
    }
    this.a.TemplateName = this.templates[this.a.templateId - 1].category
    this.a.ServiceLineName = this.selectedServiceLine
    this.a.CompetencyName = '';
    if (this.serviceLines[0] && this.a.Competency > 0) {
      this.a.CompetencyName = this.serviceLines[0].name
    }
    this.a.SubCategoryName = '';
    if (this.subServiceValues?.length > 0 && this.a.SubCompetency > 0) {
      this.a.SubCategoryName = this.subServiceValues[this.a.SubCompetency - 1].name
    }
    this.a.ServiceOfferingName = '';
    if (this.serviceOfferingForDropDownValues?.length > 0 && this.a.ServiceOffering > 0) {
      this.a.ServiceOfferingName = this.serviceOfferingForDropDownValues[this.a.ServiceOffering - 1].name
    }

    this.a.MimeType = MimeType
    this.a.FileExtension = extension
    this.a.serviceLinesForDropDown = this.serviceLinesForDropDown;
    this.a['Title'] = this.title;
    if (!Array.isArray(this.a.TemplateTags)) {
      this.a.TemplateTags = this.a.TemplateTags.split(",");
    }
    this.templatesArray[0] = this.a
    this.templatesArray

    this.closeDialog(this.templatesArray)



  }

  cancel() {
    this.dialogRef.close();
  }

  showDialog(message, navigateBack?, font?) {
    this.matdialog
      .open(InfoDialogComponent, {
        width: "280px",
        data: { message: message, class: font ? font : "text-danger" },
      })
      .afterClosed()
      .subscribe((res) => {
        if (navigateBack) {
          this.location.back();
        }
      });
  }
  getFile(index) {

    const file = this.uploads.find((ele) => ele.id === index);

    if (file) {
      return file.fileName
    }

  }
  uploadFile(data): boolean {

    var x = Array.from(data);
    x = [...new Set(x)];
    x.forEach(async (element: File) => {
      let processedFile = await Promise.resolve(this.convertFile(element))
      const extension = element.name.split('.').pop()
      if (extension !== '.pdf' && extension !== '.doc' && extension !== '.docx') {
        return false;
      }
      else {
        return true
      }

    })


    const allowedExtensions = ['docx', 'doc', 'pdf'];
    const fileExtension = data.name.split('.').pop()?.toLowerCase() || '';

    if (allowedExtensions.includes(fileExtension)) {
      return true
    } else {
      return false
    }
  }
  isFileSelected(file: File): boolean {
    if (this.selectedFileNames.includes(file.name)) {
      return true;
    }
    return false;
  }

  onSelected(option: any, dropdown: Dropdown, i) {
    dropdown.selectedOptions = option;

    const selectedOptionsSet = new Set(
      this.dropdowns.map((dropdown) => dropdown.selectedOptions)
    );

    this.optionarray = this.data.certificateCategoryTypes.filter(
      (optioned) => !selectedOptionsSet.has(optioned)
    );
    if (this.requestData[i].certificateCategorySelected) {
      this.showAlert = false;
      delete this.requestData[i].certificateCategorySelected;
    }

    this.requestData[i].certificateCategory = option != "-1" ? option : null
    this.updateAvailableOptions(dropdown, option);
  }

  updateAvailableOptions(currentDropdown?: Dropdown, myoption?: string) {
    this.selectedFiles.forEach((mydropdowns) => {
      if (mydropdowns.dropdown !== currentDropdown) {
        mydropdowns.dropdown.availableOptions = this.optionarray.filter(
          (option) => !this.dropdowns.map((d) => myoption).includes(option)
        );

        if (mydropdowns.dropdown.selectedOptions != '' && mydropdowns.dropdown.selectedOptions != 'Select Category') {
          mydropdowns.dropdown.availableOptions.push(mydropdowns.dropdown.selectedOptions);
        }

      }
    });
  }
  addSelectedFile(file: File): void {
    this.selectedFileNames.push(file.name);
  }
  categoryChange(event, file, i) {
    let value = event.target.value
    if (value && this.requestData[i].competencySelected) {
      this.showAlert = false;
      delete this.requestData[i].competencySelected;
    }
    if (value) {
      this.subCompetecy = false;
      this.subcategory[i] = this.competencies[i].find(({ id }) => id === parseInt(value)).subCompetencies;
      this.requestData = this.requestData.map((rd, i) => {
        if (rd.Name == file.name) {
          rd.CategoryId = value
          let categoryInfo = this.competencies[i].find(({ id }) => id === parseInt(value))
          rd.CategoryName = categoryInfo.name
          rd.CategoryFolderId = categoryInfo.sharepointId
        }

        return { ...rd }
      })
    }
  }

  templateCategoryChange(event) {
    let value = event.value
    if (value) {
      this.subTemplatess = false;
      this._proposalService.getSubTemplatesDropdown(parseInt(value)).subscribe((res) => {
        this.subTemplates = res.data;
      },
        error => {
          this.subTemplates = []
        })

    }

    if (this.flag)
      this.a = this.formData.getRawValue()
    this.istemplateselected = true
  }

  certificateCategoryChange(event, file, i) {
    if (this.requestData[i].certificateCategorySelected) {
      this.showAlert = false;
      delete this.requestData[i].certificateCategorySelected;
    }

    this.requestData[i].certificateCategory = event.target.value != "-1" ? event.target.value : null;
  }

  subTemplateChange(event, file, i) {
    let index = event.target.selectedIndex;
    let value = event.target.value
    if (value && this.requestData[i].subTemplateSelected) {
      this.showAlert = false;
      delete this.requestData[i].subTemplateSelected;
    }

    if (value) {
      let value = event.target.value
      this.competency = false;
      this._proposalService.getCompetencies(this.requestData[i].templateId, value).subscribe((res) => {
        this.competencies[i] = res.data;
      })
      this.requestData = this.requestData.map((rd, i) => {
        let subTemplate = this.subTemplate[i];
        if (rd.Name == file.name) {
          rd.categoryId = event.target.value;
          rd.SubCategoryTemplateId = value;
          let subTemplateInfo = subTemplate.find(({ id }) => id === parseInt(value))
          rd.SubCategoryTemplate = subTemplateInfo.subCategory
          rd.CategoryId = 0
          rd.SubCategoryId = 0
          rd.SubCategoryTemplateFolderId = subTemplateInfo.sharepointId
          rd.SharepointFolderId = subTemplateInfo.sharepointId
        }
        return { ...rd }
      })
    }
  }

  getTemplates() {
    this._proposalService.getTemplatesDropdown().subscribe((res) => {

      this.templates = res.data;
    })
  }

  getSubTemplates(id: number) {
    this._proposalService.getSubTemplatesDropdown(id).subscribe((res) => {
      this.subTemplate = res.data;
      if (id != 1) {
        this.subTemplates = res.data;
      }

    })
  }

  subCategoryChange(event, file, i) {
    let value = event.target.value
    if (value && this.requestData[i].subCompetencySelected) {
      this.showAlert = false;
      delete this.requestData[i].subCompetencySelected;
    }
    if (value) {
      this.requestData = this.requestData.map((rd, i) => {
        let subCompetencies = this.subcategory[i];
        if (rd.Name == file.name) {
          rd.SubCategoryId = event.target.value
          let subCategoryInfo = subCompetencies.find(({ id }) => id === parseInt(value))
          rd.SubCategoryName = subCategoryInfo.name
          rd.SubCategoryFolderId = subCategoryInfo.sharepointId
          rd.SharepointFolderId = subCategoryInfo.sharepointId
        }
        return { ...rd }

      })
    }
  }
  deleteAttachment(file, i) {
    this.selectedFiles = this.selectedFiles.filter(sf => sf.name !== file.name)
    this.requestData = this.requestData.filter(sf => sf.Name !== file.name)
    this.subcategory.splice(i, 1);
    if (this.selectedFileNames.length > 0) {
      var fileName = file.name.toString()
      var index = this.selectedFileNames.indexOf(fileName)
      if (index > -1) {
        this.selectedFileNames.splice(index, 1);

      }
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';

      }
    }
  }

  changeDescription(event, i) {
    if (this.requestData[i].descriptionSelected) {
      this.showAlert = false;
      delete this.requestData[i].descriptionSelected;
    }
    this.requestData[i].templateDescription = event.target.value;
  }
  convertFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }
  addTemplates() {

    if (this.requestData.length == 0) {
      this.toastr.error("Upload atleast one document")
      this.hasUploadClicked = true;
      return
    }
    this.requestData.forEach(i => {
      if (i.CategoryId && i.SubCategoryTemplate && i.templateDescription) {

        this.showAlert = false;
        i.subCompetencySelected = false;
        i.competencySelected = false;
        i.descriptionSelected = false;
        i.mimeType = i.MimeType;
        i.FileExtension = i.Name.split('.')[1];
      }
      if (this.showCategory) {

        if (!i.templateId) {
          i.templateIdSelected = true;
          this.showAlert = true;
        }
        if (!i.SubCategoryTemplate) {
          i.subTemplateSelected = true;
          this.showAlert = true;
        }
      }
      if (!this.showCategory) {
        this.showAlert = false;
      }

      if (!i.templateDescription && !this.certificateUpload) {
        i.descriptionSelected = true;
        this.showAlert = true;
      }
      if (this.certificateUpload && !i.certificateCategory) {
        i.certificateCategorySelected = true;
        this.showAlert = true;
      }
      if (i.SubCategoryTemplateFolderId) {
        i.SharepointFolderId = i.SubCategoryTemplateFolderId

      }

      if (i.CategoryFolderId) {
        i.SharepointFolderId = i.CategoryFolderId


      }
      if (i.SubCategoryFolderId) {
        i.SharepointFolderId = i.SubCategoryFolderId

      }

    })

    if (this.requestData.length > 0 && !this.showAlert) {

      this.selectedFiles = []
      this.closeDialog(this.requestData)
    }
    else if (this.showAlert) {
      this.toastr.error("Please fill all required fields");
    }
  }
  closeDialog(status) {
    this.dialogRef.close(status)

  }

  private updateControlStates(hasApproval: boolean) {
    if (hasApproval) {
        this.formData.enable({ emitEvent: false });
    } else {
        Object.keys(this.formData.controls).forEach(controlName => {
            if (controlName !== 'hasApproval') {
                this.formData.get(controlName)?.disable({ emitEvent: false });
            }
        });
    }
  }

  get hasApproval(): boolean {
    return this.formData.get('hasApproval')?.value;
  }
}
class Dropdown {
  selectedOptions: string = "Select Category";
  availableOptions: string[] = [];

  constructor(public options: string[]) {
    this.availableOptions = this.options.slice();
  }
}

